import React from 'react';
import { ToastBar, Toaster, toast } from 'react-hot-toast';
import './style.scss';
import Success from './Toast';
import { ToastOptions, ToastOptionsSchema } from './index';

export default () => {
  return (
    <Toaster position="bottom-center" reverseOrder containerClassName="hot-toaster">
      {(t) => {
        let options: ToastOptions;
        try {
          if (typeof t.message !== 'string') throw 'not a string';
          const optionsObj = JSON.parse(t.message);
          options = ToastOptionsSchema.parse(optionsObj);
        } catch (err: any) {
          return <ToastBar toast={t} />;
        }
        console.log('Toast', options);

        return (
          <Success onClose={() => toast.dismiss(t.id)} visible={t.visible} options={options} />
        );
      }}
    </Toaster>
  );
};
